<script setup>
import { modalController } from "@ionic/vue";
import { defineProps, computed } from "vue";
import { useListenConfigStore } from "@/hooks/useListenConfigStore";

const listenStore = useListenConfigStore();

const theme = computed(() => listenStore.theme);

const props = defineProps({
  message: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    default: "提示信息",
  },
  keyText:{
    type: String,
  }
});

const hancleCancel = () => {
  modalController.dismiss("cancel");
};
const hancleConfirm = () => {
  modalController.dismiss("confirm");
};
</script>

<template>
  <div class="message-box" :class="theme">
    <div class="message-box_title">{{title}}</div>
    <div class="message-box_desc">
      <div class="key-text" v-if="keyText">{{ keyText }}</div>
      <div>{{ message }}</div>
    </div>
    <div class="message-box_buttons">
      <div class="btn" @click="hancleCancel">取消</div>
      <div class="btn confirm" @click="hancleConfirm">确定</div>
    </div>
  </div>
</template>

<style scoped lang="less">
@import "ThemeTag/listenTheme";
.message-box {
  padding: 1.3rem;
  color: #333333;
  &_title {
    font-size: 1.1rem;
    font-weight: 600;
    text-align: center;
  }
  &_desc {
    font-size: 0.95rem;
    font-weight: 400;
    margin: 1.3rem 0 1.9rem;
    text-align: center;
    .key-text{
      color: var(--button-bg-color);
    }
  }
  &_buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.95rem;
    .btn {
      border: 1px solid #ccc;
      border-radius: 1rem;
      font-size: 0.9rem;
      width: 5.4rem;
      height: 2rem;
      line-height: 1.85rem;
      text-align: center;
      &.confirm {
        background-color: var(--button-bg-color);
        border-color: var(--button-bg-color);
        color: white;
      }
    }
  }
}
</style>
